/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_PLANS,
  GET_PLANS_ERROR,
  REGISTER,
  REGISTER_ERROR,
  REGISTER_EMPTY,
  VERIFY_SUCCESS,
  VERIFY_ERROR,
  SEND_VERIFICATION_MAIL,
  SEND_VERIFICATION_MAIL_FAIL,
  SEND_VERIFICATION_MAIL_EMPTY,
  LOADER,
  VERIFY_EMPTY,
  GET_PINCODEDETAIL,
  GET_PINCODEDETAIL_ERROR,
  GETOTP_SUCCESS,
  GETOTP_ERROR,
  GETOTP_EMPTY,
  OTPVALIDATE_SUCCESS,
  OTPVALIDATE_ERROR,
  OTPVALIDATE_EMPTY,
  RESET_OTP_SUCCESS,
  LOADER_HIDE,
  PLAN_DETAILS_BY_SHORT_NAME
} from 'src/actions/registerActions';

const initialState = {
  plans: null,
  plansError: null,
  registerSuccess: null,
  registerFail: null,
  verifySuccess: null,
  verifyError: null,
  sendSuccess: null,
  sendError: null,
  pinCodeDetail: null,
  pinCodeDetailError: null,
  getOtpSuccess: null,
  getOtpError: null,
  otpValidateSuccess: null,
  otpValidateError: null,
  isLoading: false,
  loadingText: '',
  planDetails: null
};

const registerReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER: {
      return produce(state, draft => {
        draft.isLoading = true;
        draft.loadingText = action.payload || null;
      });
    }
    case GET_PLANS: {
      const plans = action.payload;
      return produce(state, draft => {
        draft.plans = plans;
      });
    }
    case GET_PLANS_ERROR: {
      const plansError = action.payload;
      return produce(state, draft => {
        draft.plansError = plansError;
      });
    }
    case REGISTER: {
      const registerSuccess = action.payload;
      return produce(state, draft => {
        draft.registerSuccess = registerSuccess;
        draft.isLoading = false;
      });
    }
    case REGISTER_ERROR: {
      const registerFail = action.payload;
      return produce(state, draft => {
        draft.registerFail = registerFail;
        draft.isLoading = false;
      });
    }
    case REGISTER_EMPTY: {
      return produce(state, draft => {
        draft.registerFail = null;
        draft.registerSuccess = null;
      });
    }
    case SEND_VERIFICATION_MAIL: {
      const sendSuccess = action.payload;
      return produce(state, draft => {
        draft.sendSuccess = sendSuccess;
        draft.isLoading = false;
      });
    }
    case SEND_VERIFICATION_MAIL_FAIL: {
      const sendError = action.payload;
      return produce(state, draft => {
        draft.sendError = sendError;
        draft.isLoading = false;
      });
    }
    case SEND_VERIFICATION_MAIL_EMPTY: {
      return produce(state, draft => {
        draft.sendError = null;
        draft.sendSuccess = null;
      });
    }
    case VERIFY_SUCCESS: {
      const verifySuccess = action.payload;
      return produce(state, draft => {
        draft.verifySuccess = verifySuccess;
        draft.isLoading = Boolean(verifySuccess && verifySuccess?.['access-t']);
        draft.loadingText =
          verifySuccess && verifySuccess?.['access-t']
            ? 'Success! Your account is verified. Logging in now...'
            : '';
      });
    }
    case VERIFY_ERROR: {
      const verifyError = action.payload;
      return produce(state, draft => {
        draft.verifyError = verifyError;
        draft.isLoading = false;
      });
    }
    case VERIFY_EMPTY: {
      return produce(state, draft => {
        draft.verifySuccess = null;
      });
    }
    case GET_PINCODEDETAIL: {
      const pinCodeDetail = action.payload;
      return produce(state, draft => {
        draft.pinCodeDetail = pinCodeDetail;
        draft.isLoading = false;
      });
    }
    case GET_PINCODEDETAIL_ERROR: {
      const pinCodeDetailError = action.payload;
      return produce(state, draft => {
        draft.pinCodeDetailError = pinCodeDetailError;
        draft.isLoading = false;
      });
    }

    case GETOTP_SUCCESS: {
      const getOtpSuccess = action.payload;
      return produce(state, draft => {
        draft.getOtpSuccess = getOtpSuccess;
        draft.isLoading = false;
      });
    }
    case GETOTP_ERROR: {
      const getOtpError = action.payload;
      return produce(state, draft => {
        draft.getOtpError = getOtpError;
        draft.isLoading = false;
      });
    }
    case GETOTP_EMPTY: {
      return produce(state, draft => {
        draft.getOtpSuccess = null;
        draft.getOtpError = null;
      });
    }

    case OTPVALIDATE_SUCCESS: {
      const otpValidateSuccess = action.payload;
      return produce(state, draft => {
        draft.otpValidateSuccess = otpValidateSuccess;
        draft.isLoading = false;
      });
    }
    case OTPVALIDATE_ERROR: {
      const otpValidateError = action.payload;
      return produce(state, draft => {
        draft.otpValidateError = otpValidateError;
        draft.isLoading = false;
      });
    }
    case OTPVALIDATE_EMPTY: {
      return produce(state, draft => {
        draft.otpValidateSuccess = null;
        draft.otpValidateError = null;
      });
    }

    case RESET_OTP_SUCCESS: {
      return produce(state, draft => {
        draft.getOtpSuccess = null;
      });
    }

    case LOADER_HIDE: {
      return produce(state, draft => {
        draft.isLoading = false;
      });
    }

    case PLAN_DETAILS_BY_SHORT_NAME: {
      const planDetails = action.payload;
      return produce(state, draft => {
        draft.planDetails = planDetails;
      });
    }

    default: {
      return state;
    }
  }
};

export default registerReducer;
